export default class Timeline {
  constructor(element) {
    this.passedElement = element;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getElementsAndSetObserver();
      this.addEventListeners();
    }
  }


  getElementsAndSetObserver = () => {


    this.outerScroll = document.querySelector(".rf-scroll-progress");
    this.innerScroll = document.querySelector(".rf-scroll-progress__inner");
    this.principles = document.querySelectorAll(".rf-principle");
    // this.list = document.querySelectorAll(".rf-principle-list");


    let options = {
      // root: document.querySelector('.rf-principle-list'),
      rootMargin: '50% 0% -50% 0%',
      threshold: this.buildThresholdList(),
    }

    this.observer = new IntersectionObserver((entries, i) => {
      entries.forEach(entry => {

        if (entry.isIntersecting) {

          let number = entry.target.querySelector(".rf-scroll-progress__number");
          number.classList.add('active');

          let innerScroll = entry.target.querySelector(".rf-scroll-progress__inner");

          if(innerScroll){
            innerScroll.style.height = `${(entry.intersectionRatio * 100)}%`
          }

          if (entry.intersectionRatio >= 0.99) {
            // console.log("unobserving");
            this.observer.unobserve(entry.target);
          }
        }
      });
    }, options);


    this.principles.forEach((item, i) => {
      this.observer.observe(item);
    });


    // this.observer.observe(this.outerScroll);
  }

  buildThresholdList = () => {
    let thresholds = [];
    let numSteps = 100;

    for (let i = 1.0; i <= numSteps; i++) {
      let ratio = i / numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  }

  handleScroll = () => {

  }

  addEventListeners = () => {
    window.addEventListener('scroll', this.handleScroll);
  }

  checkIfOpen = () => {

  }

  removeEventListeners = () => {

  }

  dismantle = () => {

  }

}
